import { render } from "./WpeWysiwyg.vue?vue&type=template&id=33fb31fa"
import script from "./WpeWysiwyg.vue?vue&type=script&lang=js"
export * from "./WpeWysiwyg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/controls/WpeWysiwyg.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33fb31fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33fb31fa', __exports__)) {
    api.reload('33fb31fa', __exports__)
  }
  
  module.hot.accept("./WpeWysiwyg.vue?vue&type=template&id=33fb31fa", () => {
    api.rerender('33fb31fa', render)
  })

}


export default __exports__